import { render } from "./SignUpSuccessComponent.vue?vue&type=template&id=52de14ae&scoped=true"
import script from "./SignUpSuccessComponent.vue?vue&type=script&lang=js"
export * from "./SignUpSuccessComponent.vue?vue&type=script&lang=js"

import "./SignUpSuccessComponent.vue?vue&type=style&index=0&id=52de14ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52de14ae"]])

export default __exports__